import { dataHooks } from '@wix/data-hooks'

export const storesFunnelUpgradeDataHooks = dataHooks<{
  back: {}
  skip: {}
  next: {}
  title: {}
  subtitle: {}
  storeImage: {}
}>('stores-funnel-upgrade')
